"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var Grid_base_1 = require("./Grid.base");
var Grid_styles_1 = require("./Grid.styles");
exports.Grid = Utilities_1.styled(Grid_base_1.GridBase, Grid_styles_1.getStyles);
//# sourceMappingURL=Grid.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/utilities/grid/Grid.js
// module id = 1709
// module chunks = 0